import protoRoot from "../proto-root";

function create(motionDetectorState) {
  const MotionDetectorState = protoRoot.lookupType(`comm.MotionDetectorState`);
  const DetectorStateType = MotionDetectorState.lookupEnum("DetectorStateType");

  return MotionDetectorState.create({
    state: DetectorStateType.values[motionDetectorState]
  });
}
export default {
  create
};

// message MotionDetectorState {
//     enum DetectorStateType {
//         UNKNOWN = 0;

//         RUNNING = 1;
//         // means no need to run - motion detection is not enabled by user
//         NOT_RUNNING = 2;

//         STOPPED_REASON_LOW_CAMERA_EXPOSURE = 10;
//         STOPPED_REASON_LYING_DEVICE = 11;
//         STOPPED_REASON_FLASHLIGHT_ACTIVE = 12;

//     }

//     DetectorStateType state = 1;
// }
